import {
  ManhuntMapPoi,
  PoiWitnessContent,
  PUZZLE_TYPE,
} from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { MapPoiError } from "@/models/MapPois/Base/MapPoiError";
import { forIn, isEmpty } from "lodash";
import { db } from "@/api/firebase";

export default class Errors {
  mapPoi: ManhuntMapPoi;
  errorObject = {} as MapPoiError;
  gameUid: string;
  poiWitnessContent: PoiWitnessContent[] = [];
  constructor(mapPoi: ManhuntMapPoi, gameUid: string) {
    this.mapPoi = mapPoi;
    this.gameUid = gameUid;
  }

  checkMapPoiErrors(): MapPoiError {
    if (this.mapPoi.title.en !== "START_ZONE") {
      this.poiWitnessContent = this.getWitnessContent();
      this.checkMissingTitle();
      this.checkLocInvalid();
      this.checkTutorialInvalid();
      this.checkTargetedBy();
      this.checkChallengeContent();
      this.checkChallengeQuestionMia();
      this.checkChallengeAnswerMia();
      this.checkChallengeAnswerCodeBreakerMia();
      this.checkChallengeAnswerSlice9Mia();
      this.checkMapModsTarget();
      this.checkMapModsTriggerTarget();
      this.checkWitnessInventoryMia();
      this.checkWitnessButtonMia();
      this.checkDefaultContentMia();
      this.checkWitnessMia();
      this.checkMapModIsActiveOnWitnessRunaway();
      this.checkMapModIsActiveOnWitnessTrigger();
      this.checkPoiTypeIsPerson();
      this.checkPoiIsntTargetedTwice();
      this.checkChallNoFailOut();
      if (!isEmpty(this.errorObject)) {
        db.ref(
          "map_poi/" + this.gameUid + "/" + this.mapPoi.key + "/issues/err/"
        ).set(this.errorObject);
      } else {
        db.ref(
          "map_poi/" + this.gameUid + "/" + this.mapPoi.key + "/issues/err/"
        ).remove();
      }
    }
    return this.errorObject;
  }

  private checkMissingTitle(): void {
    if (this.mapPoi.title === undefined || this.mapPoi.title.en.length == 0) {
      this.errorObject.title_mia = {
        active: true,
        txt: { en: "General: Title is missing or empty" },
      };
    }
  }
  private checkLocInvalid(): void {
    if (
      this.mapPoi.loc.loc_uid === "" &&
      this.mapPoi.loc.override_ll.latitude == 0 &&
      this.mapPoi.loc.override_ll.longitude == 0
    ) {
      this.errorObject.loc_invalid = {
        active: true,
        txt: {
          en: "General: Location is invalid or set 0,0",
        },
      };
    }
  }
  private checkTutorialInvalid(): void {
    if (this.mapPoi.tutorial && !this.mapPoi.active) {
      this.errorObject.loc_invalid = {
        active: true,
        txt: {
          en: "General: Tutorial POIs must be active by default",
        },
      };
    }
  }
  private checkTargetedBy(): void {
    if (this.mapPoi.active && this.mapPoi.map_mods.targetedBy !== undefined) {
      this.errorObject.targetby_invalid = {
        active: true,
        txt: {
          en: "General: Targeted POIs must be inactive by default",
        },
      };
    }
  }
  private checkChallengeContent(): void {
    if (
      this.mapPoi.challenge.active &&
      (this.mapPoi.challenge.content.h_thumb.length == 0 ||
        this.mapPoi.challenge.content.txt.en.length == 0)
    ) {
      this.errorObject.chall_cont_mia = {
        active: true,
        txt: {
          en: "Challenge Lobby: Missing image or text.en",
        },
      };
    }
  }
  private checkChallengeQuestionMia(): void {
    if (
      this.mapPoi.challenge.active &&
      (this.mapPoi.challenge.puzzle.type === PUZZLE_TYPE.MULTI_CHOICE ||
        this.mapPoi.challenge.puzzle.type === PUZZLE_TYPE.CBREAKER)
    ) {
      if (
        this.mapPoi.challenge.puzzle.q === undefined ||
        this.mapPoi.challenge.puzzle.q.txt.en.length == 0
      ) {
        this.errorObject.chall_q_mia = {
          active: true,
          txt: { en: "Challenge: Question Missing" },
        };
      }
    }
  }
  private checkChallengeAnswerMia(): void {
    if (
      this.mapPoi.challenge.active &&
      this.mapPoi.challenge.puzzle.type === PUZZLE_TYPE.MULTI_CHOICE
    ) {
      if (
        this.mapPoi.challenge.puzzle.a?.a0 === undefined ||
        this.mapPoi.challenge.puzzle.a.a0.txt.en.length == 0 ||
        this.mapPoi.challenge.puzzle.a?.a1 === undefined ||
        this.mapPoi.challenge.puzzle.a.a1.txt.en.length == 0 ||
        this.mapPoi.challenge.puzzle.a?.a2 === undefined ||
        this.mapPoi.challenge.puzzle.a.a2.txt.en.length == 0
      )
        this.errorObject.chall_a_mia = {
          active: true,
          txt: { en: "Challenge: Answer Missing" },
        };
    }
  }
  private checkChallengeAnswerCodeBreakerMia(): void {
    if (
      this.mapPoi.challenge.active &&
      this.mapPoi.challenge.puzzle.type === PUZZLE_TYPE.CBREAKER
    ) {
      if (
        this.mapPoi.challenge.puzzle.a?.a0 === undefined ||
        this.mapPoi.challenge.puzzle.a.a0.txt.en.length == 0
      )
        this.errorObject.chall_a_mia = {
          active: true,
          txt: {
            en: "Challenge: Answer Missing",
          },
        };
    }
  }
  private checkChallengeAnswerSlice9Mia(): void {
    if (
      this.mapPoi.challenge.active &&
      this.mapPoi.challenge.puzzle.type === PUZZLE_TYPE.SLICE
    ) {
      if (
        this.mapPoi.challenge.puzzle.q?.sliceImg === undefined ||
        this.mapPoi.challenge.puzzle.q?.sliceImg?.length == 0
      )
        this.errorObject.chall_s9_img_mia = {
          active: true,
          txt: {
            en: "Challenge: Slice9 Image Missing",
          },
        };
    }
  }
  private checkDefaultContentMia(): void {
    if (
      this.mapPoi.default_content.txt.en.length == 0 &&
      this.mapPoi.default_content.h_thumb.length == 0
    ) {
      this.errorObject.defcont_mia = {
        active: true,
        txt: {
          en: "Default Content: Missing Image or text.en",
        },
      };
    }
  }
  private checkWitnessMia(): void {
    let warningText = "";
    let count = 0;
    if (this.mapPoi.witness.active) {
      this.poiWitnessContent.forEach((x: PoiWitnessContent) => {
        if (x.main.txt.en.length == 0 && x.main.h_thumb.length == 0) {
          warningText = warningText + "alt_" + count + ", ";
        }
        count++;
      });
    }
    if (warningText.length > 0) {
      this.errorObject.wit_cont_mia = {
        active: true,
        txt: {
          en:
            "Witness: Missing Image or text.en for " +
            warningText.substring(0, warningText.length - 2),
        },
      };
    }
  }
  private checkWitnessButtonMia(): void {
    let warningText = "";
    let count = 0;
    if (this.mapPoi.witness.active) {
      this.poiWitnessContent.forEach((x: PoiWitnessContent) => {
        //There is no next step. It's the last alt
        if (x.triggers?.target_id !== undefined) {
          if (
            x.triggers.btn_label === undefined ||
            x.triggers.btn_label?.txt.en.length == 0
          ) {
            warningText = warningText + "alt_" + count + ", ";
          }
          count++;
        }
      });
    }
    if (warningText.length > 0) {
      this.errorObject.wit_trig_label_mia = {
        active: true,
        txt: {
          en:
            "Witness: Missing targeting button label for " +
            warningText.substring(0, warningText.length - 2),
        },
      };
    }
  }
  private checkWitnessInventoryMia(): void {
    let warningText = "";
    let count = 0;
    if (this.mapPoi.witness.active) {
      this.poiWitnessContent.forEach((x: PoiWitnessContent) => {
        //There is no next step. It's the last alt
        if (x.triggers?.target_id !== undefined) {
          if (isEmpty(this.mapPoi.witness.content["alt_0"].triggers?.inv_req)) {
            warningText = warningText + "alt_" + count + ", ";
          }
          count++;
        }
      });
    }
    if (warningText.length > 0) {
      this.errorObject.wit_trig_req_mia = {
        active: true,
        txt: {
          en:
            "Witness: Missing targeting requirements label for " +
            warningText.substring(0, warningText.length - 2),
        },
      };
    }
  }

  private checkMapModsTarget(): void {
    if (
      this.mapPoi.map_mods.active &&
      this.mapPoi.map_mods.type === "runaway" &&
      this.mapPoi.map_mods.runaway?.targets === undefined
    ) {
      this.errorObject.mapmod_targets_mia = {
        active: true,
        txt: {
          en: "Mapmods Runaway: No targets",
        },
      };
    }
  }
  private checkMapModsTriggerTarget(): void {
    if (
      this.mapPoi.map_mods.active &&
      this.mapPoi.map_mods.type === "trigger" &&
      this.mapPoi.map_mods.trigger_list === undefined
    ) {
      this.errorObject.mapmod_targets_mia = {
        active: true,
        txt: {
          en: "Mapmods Trigger: No targets",
        },
      };
    }
  }

  private checkMapModIsActiveOnWitnessRunaway(): void {
    if (
      this.mapPoi.map_mods.active &&
      this.mapPoi.map_mods.type === "runaway" &&
      this.mapPoi.witness.active
    ) {
      this.errorObject.map_mods_witness_denied = {
        active: true,
        txt: {
          en: "Mapmods: CANNOT be active on a witness",
        },
      };
    }
  }

  private checkMapModIsActiveOnWitnessTrigger(): void {
    if (
      this.mapPoi.map_mods.active &&
      this.mapPoi.map_mods.type === "trigger" &&
      this.mapPoi.map_mods.set_self_inactive &&
      this.mapPoi.witness.active
    ) {
      this.errorObject.map_mods_witness_denied = {
        active: true,
        txt: {
          en: "Triggers with 'Set self inactive' CANNOT be a witness",
        },
      };
    }
  }

  private checkPoiTypeIsPerson(): void {
    if (
      this.mapPoi.type !== "person" &&
      this.mapPoi.witness &&
      (this.mapPoi.witness.suspect || this.mapPoi.witness.guilt)
    ) {
      this.errorObject.wit_non_person_suspect = {
        active: true,
        txt: {
          en:
            "Witness: Only POIs with type = person can be allocated as suspects",
        },
      };
    }
  }

  private checkPoiIsntTargetedTwice(): void {
    if (this.mapPoi.map_mods.targetedBy !== undefined) {
      if (this.mapPoi.map_mods.targetedBy.trigger !== undefined) {
        let count = 0;
        forIn(this.mapPoi.map_mods.targetedBy.trigger, () => {
          count++;
        });
        if (count > 1) {
          this.errorObject.map_mods_targetby_multiple = {
            active: true,
            txt: {
              en: "Map mods: The POI cannot be targeted by >1 POI",
            },
          };
        }
      }
    }
  }

  private checkChallNoFailOut(): void {
    if (
      this.mapPoi.challenge.active &&
      this.mapPoi.challenge.fail_timeout_s == 0 &&
      this.mapPoi.challenge.max_tries == 0
    ) {
      this.errorObject.chall_no_failout = {
        active: true,
        txt: {
          en: "Challenges must have either a timeout OR max_attempts OR both",
        },
      };
    }
  }

  //Can probs extend this on the methods
  private getWitnessContent(): PoiWitnessContent[] {
    const arr: PoiWitnessContent[] = [];
    forIn(this.mapPoi.witness.content, (val: PoiWitnessContent) => {
      arr.push(val);
    });
    return arr;
  }
}
